'use strict';

var typography = {};

exports.__exports = typography;
//# sourceMappingURL=typography.cjs.map
